import {ModalBase} from '../../../../components/Modals/ModalBase'
import InputForm from '../InputFormV2'

import PorcentageIcon from '../../../../media/felsv/Porcentaje.svg'
import DolarIcon from '../../../../media/felsv/Dollar.svg'
import {useEffect} from 'react'
import SwitchTipoProductoDTE from '../BasicSwitchTipoProducto'
import {useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {calculoDeLinea} from '../../../../utils/calculo-otros-documentos'

export default function ModalEditarProductoNR(props: any) {
  const {unidadesMedida} = useSelector((state: State) => state.catalogos)
  const {formProducto, onChangeFormProducto, onClickCerrarModalEditarProducto, onClickActualizarProducto, errors, } = props
  const {neto, descuento, subtotal, iva, total} = calculoDeLinea(formProducto, {sinIva: props.facturaExportacion})

  useEffect(() => {
    if (formProducto.exento) onChangeFormProducto('conIva', false)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formProducto.exento])

  useEffect(() => {
    if (formProducto.conIva) onChangeFormProducto('exento', false)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formProducto.conIva])

  return (
    <ModalBase>
      <div className='cf-modal-container'>
        <label className='cf-section-title'>
          {formProducto.servicio ? 'Servicio' : 'Producto'}
        </label>
        <hr className='separador' />
        <div className='label-input'>
          <InputForm
            type='select'
            options={props?.documentosAsociados ?  props.documentosAsociados.filter((doc: any) => doc.fisico === true) : []}
            keyNameText='codigoGeneracion'
            keyNameValue='codigoGeneracion'
            onChange={(e: any) => onChangeFormProducto('documentoAsociado', e.value)}
            label='Número de documento relacionado'
            value={formProducto.documentoAsociado}
          />
        </div>
        <div style={{display: 'flex', flexDirection: 'column', gap: '20px', marginBottom: '20px'}}>
          {!props.facturaExportacion && (
            <>
              {/* {!props.desactivarExento && (
                <InputForm
                  required
                  name='descripcion'
                  label='Exento'
                  type='checkbox'
                  value={formProducto.exento}
                  onChange={(e: any) => onChangeFormProducto('exento', !formProducto.exento)}
                />
              )} */}
              <div></div>
              <InputForm
                disabled={props.notaRemision}
                required
                name='descripcion'
                label='Incluye IVA'
                type='checkbox'
                value={formProducto.conIva}
                onChange={(e: any) => onChangeFormProducto('conIva', !formProducto.conIva)}
              />
              {!formProducto.exento && (
                <p style={{color: '#019FC5'}}>
                  Nota: Este {formProducto.servicio ? 'servicio' : 'producto'} lleva un 13% extra
                  por concepto de IVA. ( {formProducto.servicio ? 'Servicio' : 'Producto'} gravado)
                </p>
              )}
            </>
          )}
        </div>
        <div className='cf-row-inputs'>
          <InputForm
            disabled={props.notaRemision}
            maxLength={100}
            type='text'
            value={formProducto.descripcion}
            name='descripcion'
            onChange={(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
            placeholder='Descripción'
            required
            label='Descripción'
            error={errors.descripcion}
          />
        </div>
        <div style={{paddingTop: '20px'}}>
          <div className={`ef-form-producto-div4`}>
          <div className='label-input'>
          <InputForm
            maxLength={15}
            type='text'
            value={formProducto.cantidad}
            name='cantidad'
            onChange={(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
            placeholder='0'
            required
            label='Cantidad'
            error={errors.cantidad}
          />
          </div>
          <div className='label-input'>
          <InputForm
            disabled={props.notaRemision}
            type='select'
            value={formProducto.unidadMedida}
            name='unidad'
            onChange={(e: any) => onChangeFormProducto('unidadMedida', e.value)}
            placeholder='Unidad de medida'
            required
            label='Unidad de medida'
            options={unidadesMedida}
            keyNameText='valor'
            keyNameValue='codigo'
          />
          </div>
          <div className='label-input'>
          <InputForm
            disabled={props.notaRemision}
            maxLength={15}
            type='text'
            value={formProducto.precio}
            name='precio'
            onChange={(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
            placeholder='Precio'
            required
            label='Precio'
            error={errors.precio}
          />
          </div>
          <div className='label-input'>
          <InputForm
            disabled={props.notaRemision}
            type='select'
            value={formProducto.tipoDescuento}
            name='tipoDesc'
            onChange={(e: any) => onChangeFormProducto('tipoDescuento', e.value)}
            placeholder='Tipo de desc.'
            required
            label='Tipo de desc.'
            options={[{value: 'Porcentaje'}, {value: 'Monto'}]}
            keyNameText='value'
            keyNameValue='value'
          />
          </div>
          <div className='label-input'>
          <InputForm
            disabled={props.notaRemision}
            maxLength={formProducto.tipoDescuento === 'Porcentaje' ? 6 : 15}
            leftIcon={formProducto.tipoDescuento === 'Porcentaje' ? PorcentageIcon : DolarIcon}
            type='text'
            value={formProducto.descuento}
            name='descuento'
            onChange={(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
            placeholder='Descuento'
            label='Descuento'
            error={errors.descuento}
          />
          </div>
          </div>
        </div>
        {!props.facturaExportacion && (
          <div className='cf-calculos-producto'>
            <table>
              <tbody>
                <tr className='cf-subtotal'>
                  <td>Valor bruto</td>
                  <td>
                    {isNaN(neto)
                      ? '$0.00'
                      : neto.toLocaleString('es-SV', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          style: 'currency',
                          currency: 'USD',
                        })}
                  </td>
                </tr>
                <tr className='cf-subtotal'>
                  <td>Impuesto al Valor Agregado 13%</td>
                  <td>
                    {isNaN(iva)
                      ? '$0.00'
                      : iva.toLocaleString('es-SV', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          style: 'currency',
                          currency: 'USD',
                        })}
                  </td>
                </tr>
                <tr className='cf-subtotal'>
                  <td>Subtotal</td>
                  <td>
                    {isNaN(subtotal)
                      ? '$0.00'
                      : subtotal.toLocaleString('es-SV', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          style: 'currency',
                          currency: 'USD',
                        })}
                  </td>
                </tr>
                <tr className='cf-descuento'>
                  <td>Descuento</td>
                  <td>
                    {isNaN(descuento)
                      ? '$0.00'
                      : descuento.toLocaleString('es-SV', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          style: 'currency',
                          currency: 'USD',
                        })}
                  </td>
                </tr>
                <tr className='cf-total'>
                  <td>Total</td>
                  <td>
                    {isNaN(total)
                      ? '$0.00'
                      : total.toLocaleString('es-SV', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          style: 'currency',
                          currency: 'USD',
                        })}
                  </td>
                </tr>
              </tbody>
            </table>
            <div className='w-layout-hflex button-actions'>
              <button className='m button transparent' onClick={onClickCerrarModalEditarProducto}>
                Cancelar
              </button>
              <button className='m button' onClick={onClickActualizarProducto}>
                Actualizar
              </button>
            </div>
          </div>
        )}
        {props.facturaExportacion && (
          <div className='cf-calculos-producto'>
            <table>
              <tbody>
                <tr className='cf-subtotal'>
                  <td>Subtotal</td>
                  <td>
                    {isNaN(neto)
                      ? '$0.00'
                      : neto.toLocaleString('es-SV', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          style: 'currency',
                          currency: 'USD',
                        })}
                  </td>
                </tr>
                <tr className='cf-descuento'>
                  <td>Descuento</td>
                  <td>
                    {isNaN(descuento)
                      ? '$0.00'
                      : descuento.toLocaleString('es-SV', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          style: 'currency',
                          currency: 'USD',
                        })}
                  </td>
                </tr>
                <tr className='cf-total'>
                  <td>Total</td>
                  <td>
                    {isNaN(total)
                      ? '$0.00'
                      : total.toLocaleString('es-SV', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          style: 'currency',
                          currency: 'USD',
                        })}
                  </td>
                </tr>
              </tbody>
            </table>
            <div className='w-layout-hflex button-actions'>
              <button className='m button transparent' onClick={onClickCerrarModalEditarProducto}>
                Cancelar
              </button>
              <button className='m button' onClick={onClickActualizarProducto}>
                Actualizar
              </button>
            </div>
          </div>
        )}
      </div>
    </ModalBase>
  )
}
